import { getDate } from 'src/helpers/date';
import { GroupDetailApiResponse, MemberState } from '../types';
import { pendingMemberList, pendingMember, pendingMemberTable } from './types';

export const filterApiResponse = (
  response: GroupDetailApiResponse
): Array<MemberState> => {
  const { data } = response;

  return Object.values(data).map(member => {
    return {
      key: member.source?.id,
      id: member.source?.id,
      memberInfo: {
        id: member.source?.id,
        firstname: member.source?.first_name,
        lastname: member.source?.last_name,
        address: member.source?.places[0]?.address.formatted_address,
        mail: member.source?.primary_email?.email,
        role: member.roles?.some(role => role.name === 'administrator')
          ? 'admin'
          : 'member',
        canPublish: !!member.can_publish,
      },
    };
  });
};

export const filterPendingMembersApiResponse = (
  data: pendingMemberList
): pendingMemberTable =>
  Object.values(data).map((member: pendingMember, index: number) => {
    return {
      index: index,
      key: member.id,
      id: member.id,
      memberInfo: {
        id: member.id,
        email: member.email,
        createdAt: getDate(member.created_at),
        resentCounter: member.resent_counter,
      },
    };
  });
